import { Box, Button, DialogActions, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, Modal, Radio, RadioGroup, Select, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { ModalHeader } from "../../common/modalHeader";
import EventIcon from "@mui/icons-material/Event";
import { DateCp } from "./dateCp";
import { addCounter, updateCounter } from "./api";
import { getAllGroup } from "../customerGrouping/customerGroupingApi";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import calendar from "../../assets/icon/calendarblack.png"
export const Form = ({ open, setOpen, formDataModal, setFormDataModal, callback }) => {
    let t = {
        customer: "",
        customerMobile: "",
        birthdate: new Date(),
        anniversaryDate: new Date(),
        customerMailID: "",
        gender: "",
        customerGroup: ""
    }
    const validateData = (data) => {
        if (!data.customer || data.customer.trim() === "") {
            return { status: false, message: "Customer name is required." };
        }
        if (!data.customerMobile || data.customerMobile.trim() === "") {
            return { status: false, message: "Mobile number is required." };
        }
        if (!data.gender || data.gender.trim() === "") {
            return { status: false, message: "Gender is required." };
        }
        return { status: true };
    }
    const [formData, setFormData] = useState({ ...t })
    const [allGroups, setAllGroups] = useState([]);

    const handleClose = () => {
        setOpen(false);
        setFormDataModal(null);
        setFormData({
            customer: "",
            customerMobile: "",
            birthdate: null,
            anniversaryDate: null,
            customerMailID: "",
            gender: "",
            customerGroup: ""
        });
    };

    useEffect(() => {
        getAllGroup((data) => {
            setAllGroups(data?.data?.list)
        })
    }, [])

    useEffect(() => {
        if (open && formDataModal) {
            setFormData({
                ...formDataModal,
                customer: formDataModal?.name,
                customerMailID: formDataModal?.customerMailID,
                birthdate: formDataModal?.birthdate ? new Date(formDataModal.birthdate) : null,
                anniversaryDate: formDataModal?.anniversaryDate ? new Date(formDataModal.anniversaryDate) : null,
            });
        } else if (open && !formDataModal) {
            // Add mode
            setFormData({
                customer: "",
                customerMobile: "",
                birthdate: null,
                anniversaryDate: null,
                customerMailID: "",
                gender: "",
                customerGroup: ""
            });
        }
    }, [open, formDataModal]);

    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            background: "white",
            width: { xs: "95%", sm: "65%", md: "45%", lg: "38%", xl: "38%" },

            overflowY: "auto",
            borderRadius: "10px",
            position: "absolute",
            left: { xs: "2%", sm: "20%", md: "31%", lg: "31%", xl: "31%" },

            top: "13%",
          }}
        >
          <ModalHeader title={"Customer Details"} onClose={handleClose} />
          <Divider />
          <Box sx={{ paddingX: "20px" }}>
            <Grid container sx={{ position: "relative" }}>
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    id="briefAddress"
                    size="small"
                    label={
                      <span>
                        Customer Name: <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    InputLabelProps={{
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 500,
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 500,
                      },
                    }}
                    value={formData?.customer}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        customer: e.target.value,
                      });
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    id="briefAddress"
                    size="small"
                    // label="Mobile Number:"
                    label={
                      <span>
                        Mobile Number : <span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    InputLabelProps={{
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 500,
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 500,
                      },
                    }}
                    value={formData?.customerMobile}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setFormData({
                          ...formData,
                          customerMobile: value,
                        });
                      }
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    id="briefAddress"
                    size="small"
                    label="Email Id:"
                    InputLabelProps={{
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 500,
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 500,
                      },
                    }}
                    value={formData?.customerMailID}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        customerMailID: e.target.value,
                      });
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      className="mulish"
                      sx={{
                        marginRight: 2,
                        color: "primary.main",
                        fontSize: { xs: "12px", sm: "13px", md: "18px" },
                        fontWeight: 500,
                      }}
                    >
                      Gender:
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="Female"
                        control={<Radio />}
                        checked={formData.gender == "Female"}
                        label="Female"
                        // sx={{
                        //   ".MuiFormControlLabel-label": {
                        //     // color: "#545454",
                        //     fontWeight: 400,
                        //     fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        //     px: "7px",
                        //     fontFamily: "Mulish",
                        //   },
                        // }}
                        InputLabelProps={{
                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            cursor: "pointer",
                            fontFamily: "'Montserrat', sans-serif",
                            fontSize: { xs: "12px", sm: "13px", md: "20px" },
                            fontWeight: 500,
                          },
                        }}
                        InputProps={{
                          style: {
                            // height: '40px',
                            // background:"yellow"
                          },
                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            cursor: "pointer",
                            fontFamily: "'Montserrat', sans-serif",
                            fontSize: { xs: "12px", sm: "13px", md: "20px" },
                            fontWeight: 500,
                          },
                        }}
                        // className="mulish"
                        sx={{
                          color: "primary.main",
                          fontWeight: 500,
                          ".MuiFormControlLabel-label": {
                            // color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            px: "7px",
                            fontFamily: "Mulish",
                          },
                        }}
                        onClick={(e) => {
                          setFormData({ ...formData, gender: e.target.value });
                        }}
                      />
                      <FormControlLabel
                        value="Male"
                        control={<Radio />}
                        checked={formData.gender == "Male"}
                        label="Male"
                        className="mulish"
                        sx={{
                          color: "primary.main",
                          fontWeight: 500,
                          ".MuiFormControlLabel-label": {
                            // color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            px: "7px",
                            fontFamily: "Mulish",
                          },
                        }}
                        onClick={(e) => {
                          setFormData({ ...formData, gender: e.target.value });
                        }}
                      />
                      <FormControlLabel
                        value="Other"
                        control={<Radio />}
                        checked={formData.gender == "Other"}
                        label="Other"
                        className="mulish"
                        sx={{
                          color: "primary.main",
                          fontWeight: 500,
                          ".MuiFormControlLabel-label": {
                            // color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            px: "7px",
                            fontFamily: "Mulish",
                          },
                        }}
                        onClick={(e) => {
                          setFormData({ ...formData, gender: e.target.value });
                        }}
                      />
                    </RadioGroup>
                  </Box>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  sx={{ width: "100%", position: "relative", height: "50px" }}
                >
                  <InputLabel
                    id="customer-group-select-label"
                    sx={{
                      position: "absolute",
                      top: "0",
                      height: "50px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Customer Group
                  </InputLabel>
                  <Select
                    labelId="customer-group-select-label"
                    id="customer-group-select"
                    value={formData.customerGroup}
                    sx={{
                      height: "50px",
                      backgroundColor: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                    label="Customer Group"
                    IconComponent={() => (
                      <KeyboardArrowDownIcon
                        sx={{ fontSize: "30px", color: "primary.main" }}
                      />
                    )}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        customerGroup: e.target.value,
                      })
                    }
                  >
                    {allGroups && allGroups.length > 0 ? (
                      allGroups.map((group) => (
                        <MenuItem
                          value={group.customerGroupName}
                          key={group.id}
                        >
                          {group.customerGroupName}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No Groups</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                sm={6}
                xs={12}
                sx={{ paddingRight: { sm: "5px", xs: "0px" } }}
              >
                <Box sx={{ mt: 2, cursor: "pointer" }}>
                  <DateCp
                    label={"Date of Birth: "}
                    value={formData.birthdate}
                    setFormatDate={(data) => {
                      setFormData({
                        ...formData,
                        birthdate: data,
                      });
                    }}
                    InputLabelProps={{
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "20px" },
                        fontWeight: 500,
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "20px" },
                        fontWeight: 500,
                      },
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                sm={6}
                xs={12}
                sx={{ paddingLeft: { sm: "5px", xs: "0px" } }}
              >
                <Box sx={{ mt: 2, cursor: "pointer" }}>
                  <DateCp
                    label="Date of Anniversary:"
                    value={formData.anniversaryDate}
                    setFormatDate={(data) => {
                      setFormData({
                        ...formData,
                        anniversaryDate: data,
                      });
                    }}
                    InputLabelProps={{
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "20px" },
                        fontWeight: 500,
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "20px" },
                        fontWeight: 500,
                      },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: "15px 10px",
            }}
          >
            <Button
              variant="contained"
              sx={{ width: "50%" }}
              onClick={() => {
                if (formDataModal) {
                  let valid = validateData(formData);
                  if (valid.status) {
                    updateCounter({ ...formData }, () => {
                      callback();
                      setFormDataModal(null);
                      handleClose();
                    });
                    // setOpen(false);
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: valid.message,
                      ...swalAlertPopProps,
                    });
                  }
                } else {
                  let valid = validateData(formData);
                  if (valid.status) {
                    addCounter({ ...formData }, () => {
                      callback();
                      setFormDataModal(null);
                      handleClose();
                    });
                    // setOpen(false);
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: valid.message,
                      ...swalAlertPopProps,
                    });
                  }
                }
              }}
            >
              {formDataModal ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
    );
}